import I18n from '../../../helpers/i18n';
import { translations } from '../../../translations/translations';

const i18n = new I18n(translations.storeLocator);

export const t = i18n.get.bind(i18n);
